import {
  CompanyConfig,
  getActiveCompanyConfig,
} from "domain/company/companyConfig";

import { getAttachmentCost } from "./attachments";
import { getCostForCompany, getPannelListForCompany } from "./panelAllocation";
import { getFinalCost } from "./pricing";
import { QuoteInputDraft, QuoteResultDraft } from "./types";

export function calculatePanelsAndAttachmentsDraft(
  input: Pick<
    QuoteInputDraft,
    "lines" | "glassHeight" | "scale" | "chalkLine" | "gapSize"
  >,
  companyConfig: CompanyConfig = getActiveCompanyConfig()
): Pick<QuoteResultDraft, "pannels" | "attachment"> {
  const pannels = getCostForCompany(
    input.lines,
    {
      glassList: getPannelListForCompany(input.glassHeight, companyConfig),
      scale: input.scale,
      isChalkLine: input.chalkLine,
      gapSize: input.gapSize,
    },
    companyConfig
  );
  const attachment = getAttachmentCost(input.lines, companyConfig);

  return { pannels, attachment };
}

export function calculateQuoteTotalsDraft(
  input: Pick<
    QuoteInputDraft,
    "materialType" | "includeAttachments" | "hasDoubleDoor" | "province"
  >,
  data: Pick<QuoteResultDraft, "pannels" | "attachment">,
  companyConfig: CompanyConfig = getActiveCompanyConfig()
): Pick<QuoteResultDraft, "finalCost" | "attachment" | "totalCost"> {
  const final = getFinalCost(
    data.pannels,
    input.materialType,
    data.attachment,
    input.includeAttachments,
    input.hasDoubleDoor,
    input.province,
    companyConfig
  );

  return {
    finalCost: final.finalCost,
    attachment: final.attachment,
    totalCost: final.totalCost,
  };
}

export function calculateQuoteDraft(
  input: QuoteInputDraft,
  companyConfig: CompanyConfig = getActiveCompanyConfig()
): QuoteResultDraft {
  const base = calculatePanelsAndAttachmentsDraft(input, companyConfig);
  const totals = calculateQuoteTotalsDraft(input, base, companyConfig);

  return {
    pannels: base.pannels,
    attachment: totals.attachment,
    finalCost: totals.finalCost,
    totalCost: totals.totalCost,
  };
}
